<template>
<!-- <div id="sticky-nav" class="wrapper" > -->
  <div class="wrapper-nav">
    <transition name="slide-fadecon">
    <div class="showtt" v-if="!hiddenttv">
      <img src="@/assets/ttshow.png" class="tip-show" alt="" @click="clickhidden" v-if="!hiddenttv">
      <div class="content" >
        <div v-if="!shownew" @click="jump">{{`${getTip(baseInfo)}`}}</div>
        <div v-else @click="jump">小天邀您参加改版满意度调研</div>
        <img src="@/assets/ttclose.png" class="tiptt-close" alt="" @click="clickhiddenicom" >
      </div>
    </div>
    </transition>
    <transition name="slide-fade">
    <div class="hiddentt" v-if="hiddenttv" @click="show">
      <img alt="" @click="clickhidden" src="@/assets/tthiden.png" class="tip-close" >
    </div>
    </transition>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import {
  detailPushPage,
} from '@/utils/nativeBridge';
import StoreManger from '@/utils/FundHQJHManger';
import FundTypeSearch from '@/utils/FundTypeSearch';
import { setStorage, getStorageSync } from '@fund/storage';

export default {
  mounted() {
  },
  computed: {
    ...mapGetters({
      baseInfo: 'currentADConDate',
    }),
  },
  data() {
    return {
      hiddenttv: false,
      fundCode: '',
      fundType: '',
      linkItem: null,
      tipSkipType: '',
      shownew: false,
    };
  },
  created() {
    if (this.getCache('tiantiantipHiden') === '1') {
      this.hiddenttv = true;
    }
    const mindex = getStorageSync('ef-fund-newtopGuiTT');
    if (mindex !== '1') {
      this.shownew = false;
    }
  },
  methods: {
    setHidView() {
      this.shownew = false;
      setStorage('ef-fund-newtopGuiTT', '1');
    },
    render() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
      const mindex = getStorageSync('ef-fund-newtopGuiTT');
      if (mindex !== '1') {
        this.shownew = false;
      } else {
        this.shownew = false;
      }
    },
    show() {
      // pz.btn.znzl.click

      this.hiddenttv = false;
      this.reportMonitor({
        eventName: 'pz.btn.znzl.click',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    jump() {
      if (this.shownew) {
        this.setHidView();
        detailPushPage({
          type: '1',
          url: 'https://act.1234567.com.cn/dwsurvey/diaowen/jqcp8d0i.html',
        });
        return;
      }
      // #if EXECUTION_ENV === 'web'
      detailPushPage({
        appId: '6f5a3debe5b44f5da7aacb7c58957bc3',
        url: '/pages/index',
      });
      // #endif
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      const systemInfo = fund.getSystemInfoSync();
      if (this.tipSkipType === '2') {
        let m = '';
        const t = this.getTip(this.baseInfo);
        if (t) {
          const baseInfo = StoreManger.getFundJJXQ();
          const name = StoreManger.getFundJJXQNAME(baseInfo);
          m = `${name}的基金诊断`;
        }
        // eslint-disable-next-line no-undef
        if (fund.presentPage) {
          const hssA = systemInfo.screenHeight * systemInfo.scale * 0.85;
          const hss = Math.ceil(hssA / systemInfo.pixelRatio);
          // eslint-disable-next-line no-undef
          fund.presentPage({
            // envVersion: 'develop', // 默认 release
            url: `/pages/index?message=${m}&hideStatusBar=true`,
            // closeCurrentDialog: true,
            // animation: false,
            // disableSwipeBack: true,
            appId: '6f5a3debe5b44f5da7aacb7c58957bc3',
            // eslint-disable-next-line no-mixed-operators
            pageHeight: hss,
            navigationBarDisplay: false,
          });
        } else {
          detailPushPage({
            appId: '6f5a3debe5b44f5da7aacb7c58957bc3',
            url: '/pages/index',
          });
        }
      } else {
        const { LinkType, LinkTo } = this.linkItem;
        detailPushPage({
          type: LinkType,
          url: LinkTo,
        });
      }
      // #endif
    },
    setCache(key, value) {
      window.localStorage.setItem(key, value);
    },
    getCache(key) {
      return window.localStorage.getItem(key);
    },
    clickhiddenicom() {
      this.setHidView();
      this.hiddenttv = true;
      this.setCache('tiantiantipHiden', '1');
      setStorage('ef-fund-newtopGuiTT', '1');
      this.reportMonitor({
        eventName: 'pz.btn.gbznzl.click',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    clickhidden() {
      this.hiddenttv = true;
      this.setCache('tiantiantipHiden', '1');
    },
    hidden() {
      this.hiddenttv = true;
    },
    getTip(item) {
      const ttdata = this.getDataList(item);
      if (ttdata) {
        const tip = this.getConfigureData(ttdata);
        if (tip) {
          console.log(tip);
          return tip;
        }
      }
      console.log('tip');
      this.tipSkipType = '2';
      return '问小天：这只基金怎么样？';
    },
    getDataList(variInfo) {
      if (!variInfo) {
        return null;
      }
      let ModulesData = null;
      const { datas } = variInfo;
      if (datas) {
        if (datas.Modules) {
          ModulesData = datas.Modules;
        }
      }
      if (ModulesData) {
        const showModules = ModulesData.filter(
          (item) => (item.ModuleCode === 'FundDetailDrogueAd' && item.CustomArray.length > 0),
        );
        if (showModules.length > 0) {
          const showModule = showModules[0];
          let { CustomArray } = showModule;
          CustomArray = CustomArray.filter((item) => item.FloatText).map((item) => {
            const result = item;
            return result;
          });
          return CustomArray[0];
        }
      }
      return null;
    },
    isExchangeFund() {
      return FundTypeSearch.isExchangeFund(this.fundType);
    },
    isNewFund() {
      return FundTypeSearch.isNewFund(this.fundType);
    },
    isMonetaryfund() {
      return FundTypeSearch.isMonetaryfund(this.fundType);
    },
    getConfigureData(item) {
      // FundType 1-权益 2-货币 3-场内 4-新发
      if (!item) {
        return null;
      }
      const {
        ExcludeCodes,
        FundType,
        IncludeCodes,
        FloatText,
        SkipType,
        Link,
      } = item;
      if (IncludeCodes && IncludeCodes.indexOf) {
        if (IncludeCodes.indexOf(this.fundCode) !== -1) {
          this.tipSkipType = SkipType;
          this.linkItem = Link;
          return FloatText;
        }
      }
      if (ExcludeCodes && ExcludeCodes.indexOf) {
        if (ExcludeCodes.indexOf(this.fundCode) !== -1) {
          return null;
        }
      }
      if (FundType) {
        const liststr = FundType;
        if (liststr.indexOf) {
          if (liststr.indexOf('1') !== -1) {
            if (!this.isNewFund() && !this.isExchangeFund() && !this.isMonetaryfund()) {
              this.tipSkipType = SkipType;
              this.linkItem = Link;
              return FloatText;
            }
          }
          if (liststr.indexOf('2') !== -1) {
            if (this.isMonetaryfund()) {
              this.tipSkipType = SkipType;
              this.linkItem = Link;
              return FloatText;
            }
          }
          if (liststr.indexOf('3') !== -1) {
            if (this.isExchangeFund()) {
              this.tipSkipType = SkipType;
              this.linkItem = Link;
              return FloatText;
            }
          }
          if (liststr.indexOf('4') !== -1) {
            if (this.isNewFund()) {
              this.tipSkipType = SkipType;
              this.linkItem = Link;
              return FloatText;
            }
          }
        }
      }
      return null;
    },
    clickItem() {
      if (this.linkItem) {
        const { LinkType, LinkTo } = this.linkItem.Link;
        detailPushPage({
          type: LinkType,
          url: LinkTo,
        });
      } else {
        //
      }
    },
  },
};
</script>

<style lang="less" scoped>

.wrapper-nav{
  position: fixed;
  top: 75%;
  left: 0;
  z-index: 8888;
}
.hiddentt{
  height: 48px;
  width: 48px;
  position: absolute;
  top: 0;
  left: 0;
}
.tip-close{
  height: 96px;
  width: 59px;
}
.showtt{
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
}
.tip-show{
  height: 96px;
  width: 114px;
}
.content{
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #000000;
  letter-spacing: 0;
  line-height: 50px;
  background: #F0F7FF;
  border: 1px solid #DCEAFA;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 20px;
  padding-left: 30px;
  padding-right: 50px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.tiptt-close {
  width: 42px;
  height: 42px;
  position: absolute;
  right: 0;
  top: 0;
}
@keyframes mymoveenter
{
  0%  {left: -80px;}
  50%  {left: -80px;}
  100% {left: 0;}
}
.slide-fade-enter-active {
    // transition: all 12s ease;
    animation: mymoveenter 1s;
  }
  .slide-fade-leave-active {
    transition: all .3s ease;
  }
  .slide-fade-enter{
    //transform: translate(-80px,0px);
    // animation: mymoveenter 12s;
  }
  .slide-fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {

    transform: translate(-800px,0px);
    opacity: 1;
  }
  .slide-fadecon-enter-active {
    transition: all .6s ease;
  }
  .slide-fadecon-leave-active {
    transition: all .6s ease;
  }
  .slide-fadecon-enter{
    transform: translate(-800px,0px);
    opacity: 1;
  }
  .slide-fadecon-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translate(-800px,0px);
    opacity: 1;
  }
</style>
